import { configureStore } from "@reduxjs/toolkit";
import drawerReducer from "./slices/drawer-slice";
import sparketTutorialReducer from "./slices/sparket-tutorial-slice";
import groupReducer from "./slices/group-slice";
import availableGroupsReducer from "./slices/available-groups-slice";
import legalModalReducer from "./slices/legal-modal-slice";
import externalIdModalReducer from "./slices/external-id-modal-slice";
import loginModalsReducer from "./slices/login-modals-slice";
import userSlice from "./slices/user-slice";
import contestPopupModalSlice from "./slices/contest-popup-modal-slice";
import integratedAppSlice from "./slices/integrated-app-slice";
import userSettingsSlice from "./slices/user-settings-slice";
import avatarModalSlice from "./slices/avatar-modal-slice";
import appConfigSlice from "state/slices/app-config-slice";
import contestSlice from "state/slices/contests-slice";
import myPicksPopoutSlice from "./slices/my-picks-popout-slice.ts";
import userPaymentMethodsSlice from "state/slices/user-payment-methods-slice.ts";
import userRealWalletSlice from "state/slices/user-real-wallet-slice.ts";
import userOrdersSlice from "state/slices/user-orders-slice.ts";
import productsSlice from "state/slices/products-slice.ts";
import battlePassesSlice from "state/slices/battle-passes-slice.ts";
import redirectFromInovioPageSlice from "state/slices/redirect-from-inovio-page-slice.ts";
import adContestReducer from "./slices/adContestSlice";
import partnerGameSlice from "./slices/partner-game-slice.ts";
import betsReducer from "./slices/bets-slice";
import walletSlice from "./slices/wallet-slice";
import withdrawFundsModalSlice from "./slices/withdraw-funds-modal-slice";
import globalLoadingOverlaySlice from "./slices/global-loading-overlay-slice";
import userWithdrawalRequestsSlice from "./slices/user-withdrawal-requests-slice";
import bankAccountsSlice from "./slices/bank-accounts-slice";
import depositFundsModalV2Slice from "./slices/deposit-funds-modal-v2-slice";
import consoleReducer from "./slices/console-slice";
import networkReducer from "./slices/network-slice";

const store = configureStore({
  reducer: {
    drawer: drawerReducer,
    legalModal: legalModalReducer,
    sparketTutorial: sparketTutorialReducer,
    group: groupReducer,
    availableGroups: availableGroupsReducer,
    externalIdModal: externalIdModalReducer,
    loginModals: loginModalsReducer,
    user: userSlice,
    userSettings: userSettingsSlice,
    contestPopupModal: contestPopupModalSlice,
    integratedApp: integratedAppSlice,
    avatarModal: avatarModalSlice,
    appConfig: appConfigSlice,
    contests: contestSlice,
    myPicksPopout: myPicksPopoutSlice,
    paymentMethods: userPaymentMethodsSlice,
    realWallet: userRealWalletSlice,
    orders: userOrdersSlice,
    products: productsSlice,
    battlePasses: battlePassesSlice,
    inovioRedirectOrderId: redirectFromInovioPageSlice,
    adContest: adContestReducer,
    bets: betsReducer,
    wallet: walletSlice,
    withdrawFundsModal: withdrawFundsModalSlice,
    globalLoadingOverlay: globalLoadingOverlaySlice,
    withdrawalRequests: userWithdrawalRequestsSlice,
    bankAccounts: bankAccountsSlice,
    depositFundsModalV2: depositFundsModalV2Slice,
    console: consoleReducer,
    network: networkReducer,
    partnerGame: partnerGameSlice,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
